import React from 'react';

export const modulePortDraft = (module, override = {}) => {
  let options = {};
  try { options = JSON.parse(module.deployment?.settings?.createOptions || '{}'); } catch { /* Keep explicit fields editable. */ }
  const bindings = Object.entries(options.HostConfig?.PortBindings || {}).flatMap(([key, values]) =>
    key.endsWith('/tcp') ? values.map(value => ({ hostPort: value.HostPort, containerPort: key.split('/')[0] })) : []);
  const baseHost = module.hostPort ?? module.port ?? '';
  const matching = bindings.filter(binding => String(binding.hostPort) === String(baseHost));
  const binding = matching.length === 1 ? matching[0] : bindings.length === 1 ? bindings[0] : undefined;
  const hostNetwork = override.hostNetwork ?? module.hostNetwork ?? (options.HostConfig?.NetworkMode ? options.HostConfig.NetworkMode === 'host' : bindings.length === 0);
  const hostPort = override.hostPort ?? override.exposedPort ?? override.uiPort ?? module.hostPort ?? module.port ?? binding?.hostPort ?? '';
  return {
    hostNetwork,
    hostPort,
    containerPort: override.containerPort ?? module.containerPort ?? (hostNetwork ? hostPort : binding?.containerPort ?? '')
  };
};

export const portPayload = (draft, browserEnabled) => {
  const result = { hostNetwork: draft.hostNetwork !== false };
  for (const field of ['hostPort', 'containerPort']) {
    const raw = draft[field];
    if (raw === '' || raw === undefined || raw === null) continue;
    const value = Number(raw);
    if (!Number.isInteger(value) || value < 1 || value > 65535) throw new Error(`${field === 'hostPort' ? 'Host' : 'Container'} port must be an integer from 1 to 65535.`);
    result[field] = value;
  }
  if ((result.hostPort === undefined) !== (result.containerPort === undefined)) throw new Error('Supply both host and container ports, or leave both empty.');
  if (browserEnabled && result.hostPort === undefined) throw new Error('Browser access requires a host port.');
  if (result.hostNetwork && result.hostPort !== result.containerPort) throw new Error('Host networking requires matching host and container ports.');
  return result;
};

const ModulePorts = ({ value, onChange, disabled = false }) => <>
  <label>Host port<input type="number" min="1" max="65535" step="1" value={value.hostPort ?? ''} disabled={disabled} onChange={event => onChange({ hostPort: event.target.value, ...(value.hostNetwork ? { containerPort: event.target.value } : {}) })} placeholder="No port" /><small>Browser access routes to this port on the demo host.</small></label>
  <label>Container port<input type="number" min="1" max="65535" step="1" value={value.containerPort ?? ''} disabled={disabled || value.hostNetwork} onChange={event => onChange({ containerPort: event.target.value })} placeholder="Application listening port" /><small>{value.hostNetwork ? 'Same as the host port with host networking.' : 'The port the application listens on inside its container.'}</small></label>
  <label className="module-catalog-wide module-catalog-external-toggle"><span>Network</span><span><input type="checkbox" checked={value.hostNetwork === true} disabled={disabled} onChange={event => {
    const hostNetwork = event.target.checked;
    const port = value.containerPort || value.hostPort || '';
    onChange({ hostNetwork, ...(hostNetwork ? { hostPort: port, containerPort: port } : {}) });
  }} /> Use host networking</span><small>{value.hostNetwork ? 'The application must listen on the host port; Docker port mapping is disabled.' : 'Docker maps the host port to the container port. This does not change the application’s listening port.'}</small></label>
</>;

export default ModulePorts;
